import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const waiverContentMutations: UpdatesConfig['Mutation'] = {
  waiverContentCreate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery('waiverContents', cache);
  },
  waiverContentStatusUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery('waiverContents', cache);
  },
};

export default waiverContentMutations;
